import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type LoadingFillProps = {
  progress: number
}

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${theme.spacing.sm};
`

export const Spinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 48px;
  border-radius: 50%;
  background-color: ${theme.colors.primary[80]};
  animation: spin 3s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.xs};

  p {
    color: ${theme.colors.primary[20]} !important;
  }
`

export const LoadingBar = styled.div`
  width: 100%;
  height: ${theme.spacing.xs};
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.primary[80]};
`

export const LoadingFill = styled.div<LoadingFillProps>`
  width: ${({ progress }) => `${progress}%`};
  height: ${theme.spacing.xs};
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.primary[60]};
  transition: width 0.3s ease-in-out;
`
